import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Table from "../components/Table";
import axios from "axios";
import { apiKey } from "../config/config";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function SellInventoryList({ lang }) {
  const token = JSON.parse(sessionStorage.getItem("aman-admin") || "null")
    ?.admin
    ? JSON.parse(JSON.parse(sessionStorage.getItem("aman-admin")).admin).token
    : null;

  const [sellList, setSellList] = useState([]);
  const [branchId, setBranchId] = useState();

  useEffect(() => {
    setBranchId(
      JSON.parse(JSON.parse(sessionStorage.getItem("aman-admin")).admin).branch_id
    );
  }, []);

  useEffect(() => {
    if (!branchId) return;

    axios
      .get(apiKey + "/sell-item-list", {
        params: { branch_id: branchId },
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => setSellList(res.data.result || []))
      .catch((err) => {
        console.error(err);
        toast.error("Error loading sell items");
      });
  }, [branchId, token]);

  const columns = [
    { header: lang["SN"], cell: (row) => row.row.index + 1 },
    { header: lang.Item || "Item", accessorKey: "inventory_item" },
    { header: lang.Investor || "Investor", accessorKey: "investor_name" },
    { header: lang.Type || "Type", accessorKey: "type", cell: item => item.getValue() === "buy" ? "Buying" : "Selling" },
    {
      header: lang.Price || "Price",
      accessorKey: "sell_price",
    },
    { header: lang.Quantity || "Quantity", accessorKey: "quantity" },
    {
      header: lang.Actions || "Actions",
      cell: () => <span className="px-3 py-2 badge bg-success">{lang["Sold"] || "Sold"}</span>,
    },
  ];

  return (
    <main id="main" className="main">
      <ToastContainer
        position="bottom-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />

      <div className="pagetitle">
        <h1>
          {lang.Investment_Loan_Management || "Investment/Loan Management"}
        </h1>
        <nav>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="14"
                viewBox="0 0 24 24"
              >
                <path d="m21.743 12.331-9-10c-.379-.422-1.107-.422-1.486 0l-9 10a.998.998 0 0 0-.17 1.076c.16.361.518.593.913.593h2v7a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-4h4v4a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-7h2a.998.998 0 0 0 .743-1.669z"></path>
              </svg>
            </li>
            <li className="breadcrumb-item ">
              {lang.Investment_Loan_Management || "Investment/Loan Management"}
            </li>
            <li className="breadcrumb-item active">
              {lang["Sell Items List"] || "Sell Items List"}
            </li>
          </ol>
        </nav>
      </div>

      <section className="section">
        <div className="row">
          <div className="col-lg-12">
            <div className="card">
              {/* SELL NEW ITEM BUTTON */}
              <div className="row justify-content-end">
                <div className="col-md-5 col-lg-3">
                  <Link to="sell-new-item">
                    <button className="btn btn-primary">
                      {lang['Sell New Item'] || "Sell New Item"}
                    </button>
                  </Link>
                </div>
              </div>

              <div className="row pt-3">
                <div className="rr col-9">
                  {lang["Sell Items List"] || "Sell Items List"}
                </div>
              </div>

              <div className="card-body">
                <Table data={sellList} columns={columns} lang={lang} />
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
